// Norwegian counties (fylker), used to group municipalities by countyId.
export const counties = [
    { id: 3, name: 'Oslo' },
    { id: 11, name: 'Rogaland' },
    { id: 15, name: 'Møre og Romsdal' },
    { id: 18, name: 'Nordland' },
    { id: 31, name: 'Østfold' },
    { id: 32, name: 'Akershus' },
    { id: 33, name: 'Buskerud' },
    { id: 34, name: 'Innlandet' },
    { id: 39, name: 'Vestfold' },
    { id: 40, name: 'Telemark' },
    { id: 42, name: 'Agder' },
    { id: 46, name: 'Vestland' },
    { id: 50, name: 'Trøndelag' },
    { id: 55, name: 'Troms' },
    { id: 56, name: 'Finnmark' },
];
